/**
 * des：租户管理--产品试用申请
 * date：2018-1-10
 * author：lileilei
 */
"use strict";
angular.module('productTrialModule', [])
    .controller('productTrialCtrl', ["$scope", "trsspliceString", "$q", "$filter", "tManageMentService", "modalDialog", "trsHttpService",
        function($scope, trsspliceString, $q, $filter, tManageMentService, modalDialog, trsHttpService) {
            initStatus();
            initData();

            /** [initStatus description]初始化状态 */
            function initStatus() {
                $scope.status = {
                    searchValue: '',
                    statusList: [{
                        name: '全部',
                        value: ''
                    }, {
                        name: '已处理',
                        value: '1'
                    }, {
                        name: '处理中',
                        value: '2'
                    }, {
                        name: '未处理',
                        value: '3'
                    }],
                    searchTypelist: [{
                        name: '全部',
                        value: 'searchValue'
                    }, {
                        name: '联系人',
                        value: 'name'
                    }, {
                        name: '公司名',
                        value: 'companyname'
                    }]
                };
                $scope.data = {
                    copyCurrPage: 1,
                    selectedArray: [],
                    applicationLists: [],
                    status: {
                        '1': '已处理',
                        '2': '处理中',
                        '3': '未处理'
                    }
                };
                $scope.page = {
                    PAGESIZE: 20,
                    PAGECOUNT: 1,
                    ITEMCOUNT: 0,
                    CURRPAGE: 1,
                };
                $scope.params = {
                    serviceid: "mlf_trialapplication",
                    methodName: 'queryTrialApplications',
                    searchValue: ''
                };
                $scope.status.selectedStatus = $scope.status.statusList[0];
                $scope.status.searchType = $scope.status.searchTypelist[0];
                $scope.searchType = 'searchValue';
            }
            /** [initData description]初始化数据 */
            function initData() {
                requestData();
            }

            function requestData() {
                $scope.params.status = $scope.status.selectedStatus.value;
                $scope.params.CURRPAGE = $scope.page.CURRPAGE;
                $scope.params.PAGESIZE = $scope.page.PAGESIZE;
                $scope.params[$scope.searchType] = $scope.status.searchValue;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                    $scope.data.applicationLists = data.DATA;
                    $scope.page = data.PAGER;
                    $scope.data.copyCurrPage = $scope.page.CURRPAGE;
                });
            }
            /**
             * [searchWord description] 搜索
             * @param {[string]}  [description]
             */
            $scope.searchWord = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    requestData();
                }
            };
            /**
             * [requestData description] 再次请求
             * @param {[string]}  [description]
             */
            $scope.requestData = function() {
                requestData();
            };
            /** [jumpToPage description]手动输入页码进行跳转的操作 */
            $scope.jumpToPage = function() {
                $scope.page.CURRPAGE = $scope.data.copyCurrPage;
                requestData();
            };
            /**
             * [selectFilterTypem description] 选中下拉菜单
             * @param {[string]} [attribute1] [description]
             * @param {[string]} [attribute2] [description]
             */
            $scope.selectFilterType = function() {
                requestData();
            };
            /**
             * [serachByType description] 搜索条件
             * @param {[string]} [attribute1] [description]
             * @param {[string]} [attribute2] [description]
             */
            $scope.serachByType = function(type) {
                $scope.params = {
                    serviceid: "mlf_trialapplication",
                    methodName: 'queryTrialApplications',
                };
                $scope.searchType = type.value;
            };
            /**
             * [selectItem description] 选中产品
             * @param {[object]} [item] [description] 选中租户
             */
            $scope.selectItem = function(item) {
                if ($scope.data.selectedArray.indexOf(item) < 0)
                    $scope.data.selectedArray.push(item);
                else
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            };
            /**
             * [selectAll description] 全选产品
             */
            $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.data.applicationLists.length ? [] : (function() {
                    var array = [];
                    for (var i = 0; i < $scope.data.applicationLists.length; i++) {
                        array.push($scope.data.applicationLists[i]);
                    }
                    return array;
                })();
            };
            /**
             * [ editAppliction description] 修改产品申请
             *  @param {[date]} [varname] [description]所选日期
             */
            $scope.editAppliction = function(item) {
                var params = {
                    serviceid: "mlf_trialapplication",
                    methodName: 'findApplicationById',
                    ObjectId: item.TRIALAPPLICATIONID
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    tManageMentService.editAppliction(data).then(function(data) {
                        requestData();
                    });
                });

            };

        }
    ]);